import { Button } from '#/shared/components/Button';
import { Modal, ModalContent } from '#/shared/components/Modal';
import { usePaidBreakExceptionStore } from '#/shared/stores/paidBreakExceptionStore';

export interface RejectAllModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function RejectAllModal({ isOpen, onClose }: Readonly<RejectAllModalProps>) {
  const rejectAllExceptions = usePaidBreakExceptionStore(s => s.rejectAllExceptions);

  const handleConfirm = () => {
    rejectAllExceptions();
    onClose();
  };

  return (
    <Modal isOpen={isOpen}>
      <ModalContent title={'Reject all paid break exception requests?'} onCancel={onClose}>
        {/* "overflow-y-auto" so the middle section scrolls */}
        <div className="px-24 pb-4 flex flex-col gap-16 overflow-y-auto">
          <p>All accepted paid break exception requests will be rejected.</p>
          <p>You will still be able to accept or reject individual requests before approving the timesheet.</p>
        </div>

        <div className="px-24 flex gap-12">
          <Button variant="primaryOutline" size="medium" onPress={onClose} className="w-full">
            Cancel
          </Button>
          <Button size="medium" className="w-full" onPress={handleConfirm}>
            Reject all requests
          </Button>
        </div>
      </ModalContent>
    </Modal>
  );
}
